export default __webpack_public_path__ + "844593891310bfdff607f11fc52ff73a.png";